import React, {useEffect} from 'react';
import styled from 'styled-components';
import {Col, Container, Form, Row} from 'react-bootstrap';
import {toast} from 'react-toastify';
import {useForm} from 'react-hook-form';
import {postForm} from '../../api/redux/contact';
import {useDispatch, useSelector} from 'react-redux';
import {apiEndPoints} from '../../api/network/apiEndPoints';
import {hover, text, white} from '../../styles/globalStyleVars';
import ButtonSubmit from '../nzuac-buttons/ButtonSubmit';


const NZUACModal = ({padding, data, id, pt}) => {


  const dispatch = useDispatch();
  const responseData = useSelector(state => state.CONTACT);


  const {register, handleSubmit, formState, reset} = useForm({mode: 'all'});


  // --- form submit
  const success = (msg) => toast.success(msg, {
    position: 'top-right', autoClose: 4000, closeOnClick: true, progress: undefined,

  });

  const error = (msg) => toast.error(msg, {
    position: 'top-right', autoClose: 4000, closeOnClick: true, progress: undefined,

  });


  const onSubmit = async (e) => {

    let api_services = apiEndPoints.FORM_SUBMIT;

    var formData = new FormData();
    formData.append('name', e?.name);
    formData.append('email', e?.email);
    formData.append('message', e?.message);
    formData.append('form_id', 'opening-modal');

    if (e.email !== '' && e.name !== '') {
      await dispatch(postForm([api_services, formData]));
      success('Form submit successfully');

      reset();
    }
  };
  let count = 0;

  const onError = (errors) => {
    Object.values(errors).forEach((error) => {
      count++;
    });
    if (count > 0) {
      toast.error('Please fill out the correct inputs');
    }
    count = 0;
  };
  useEffect(() => {
    if (responseData && responseData?.error !== '') {
      error(responseData?.error);
    }
    if (responseData && responseData?.success !== '') {
      success(responseData?.success);
    }
  }, [responseData]);






  return (<StyledListWithForm pt={pt} id={`${id ? id : 'ListWithForm'}`}

    className={'list_with_form  '}>
    <Container fluid className={'p-0 m-0 heightOk'}>
      <Row className={'m-0 heightOk'}>
        <Col className={'form-column p-0'} md={12}>
          <div className="form_wrapper ">

            <h4>Share Your Details and Questions</h4>
            
            <Form className={'form'} onSubmit={handleSubmit(onSubmit, onError)}>

              <input name={'spam_protector'} type="hidden"/>
              <input name={'form_id'} value={'opening-modal'} type="hidden"/>
              <div className="form-group">
                <Form.Group controlId="formBasicEmail">

                  <Form.Control
                    className={formState?.errors?.name?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                    {...register('name', {
                      required: 'Name is required',

                    })}
                    type="text"
                    placeholder="Name*"
                  />
                </Form.Group>
              </div>
              <div className="form-group">
                <Form.Group controlId="formBasicEmail">

                  <Form.Control
                    className={formState?.errors?.email?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                    {...register('email', {
                      required: {
                        value: true, message: 'please enter your email'
                      }, pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'please enter a valid email address'
                      }
                    })}
                    type="email"
                    placeholder="Email*"/>
                </Form.Group>
              </div>

              <div className="form-group">
                <Form.Group controlId="formBasicPhone">
                  <textarea
                    className={formState?.errors?.email?.message ? 'has-error form-control-lg textarea form-control' : 'textarea form-control form-control-lg'}
                    {...register('message', {
                      required: {
                        // value:true,
                        message: '',
                      },
                    })}
                    placeholder="Ask Question"
                    rows={4} // You can adjust the number of rows as needed
                  />
                </Form.Group>

              </div>


              <div className="note">
                <p>* NZUAC will not share your details with others</p>
              </div>
              <div className={'form-group '}>
                <div onClick={handleSubmit(onSubmit, onError)}>
                  <ButtonSubmit height={40} width={150} text={'Submit'} hoverTextcolor={white} borderColor={white} background={hover} hoverBackground={text}/>
                </div>
              </div>

            </Form>
          </div>
        </Col>


      </Row>
    </Container>
  </StyledListWithForm>);
};

const StyledListWithForm = styled.div`
  box-sizing: border-box;
  position: relative;
  max-width: 100%;
  width: 100%;
  height: 100svh;

  .single_content_wrp {
    padding: 120px 0 120px 120px !important;
    @media (max-width: 992px) {
      padding: 70px 0 70px 70px !important;

    }
  }

  .social {
    a {
      &:hover {
        path {
          fill: ${text} !important;
        }
      }
    }
  }

  &:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F1F0EE;
    height: 50%;
    width: 100%;
    content: '';
    z-index: -1;

  }

    &:before {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        background: ${text};
        height: 50%;
        width: 100%;
        content: '';
        z-index: -1;
    }

    .note {
        margin-bottom: 30px;

        p {
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }
    }

    .form_wrapper {
        padding: 40px;
        position: relative;
        // overview_bg

  


        form {
            display: flex;
            height: auto;
            flex-direction: column;
        }

        .textarea {
            min-height: 120px;
        }

        .title {
            font-size: 24px;
            font-weight: 4000;
            line-height: 28px;
            color: #F9F9F9;
            margin: 0 0 40px;
        }

        .form-group {
            margin-bottom: 30px;
            width: 100%;

            &:last-child {
                margin-bottom: 0;
            }

            svg {
                display: block;
            }

            .form-control {
                box-shadow: none;
                outline: 0;
                border-radius: 0;
                background: transparent;
                height: auto;
                border-left: none;
                border-right: none;
                border-top: none;
                border-color: rgba(4, 5, 4, 0.2);
                padding: 0 0 8px;
                color: #040504;
                font-size: 16px;
                font-weight: 400;
                line-height: 20px;

                svg {
                    display: block;
                }

                &:focus {
                    border-color: rgba(4, 5, 4, 1);

                }

                &::placeholder {
                    color: rgba(4, 5, 4, 0.4);
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 20px;
                }
            }
        }


    }

    .row {
        .form-group {
            margin-bottom: 0 !important;
            @media (min-width: 1535px) {
                margin-bottom: 0 !important;
            }
        }
    }

    .form-column {
        background: ${white};
    }


    .form_wrapper {
        .row {
            margin: 0;
            width: 100%;
            gap: 15px;
            justify-content: space-between;

            .col-md-6 {
                flex: 0 0 calc(50% - 15px);
                max-width: calc(50% - 15px);
                padding-left: 0;
                padding-right: 0;
            }
        }
    }


    //selector

    .filter__control {
        border-left: none;
        border-right: none;
        border-radius: 0;
        border-top: none;
        padding-left: 0;

        .filter__value-container {
            padding-left: 0;
            padding-right: 0;
        }

        .filter__single-value {
            color: rgba(4, 5, 4, 1);
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
        }

        .filter__placeholder {
            color: rgba(4, 5, 4, 0.4);
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
        }

        .filter__indicator-separator {
            display: none;
        }

        .filter__indicator {
            padding-right: 0;
        }
    }

    .filter__control--is-focused {
        outline: none;
        border-bottom: 1px solid rgba(4, 5, 4, 0.2) !important;
        box-shadow: none;
    }


    @media (max-width: 992px) {
        transform: none;
        .social {
            align-items: flex-start !important;
            justify-content: flex-start !important;
        }

        .col-md-6 {
            flex: 0 0 100%;
            max-width: 100%;
        }

        .container-fluid {
            padding-left: 0 !important;
        }

        .single_content_wrp {
            padding: 40px 20px;
            @media (max-width: 767px) {
                padding: 50px !important;
            }
        }

        .form_wrapper {
            padding: 40px 20px;
            @media (max-width: 767px) {
                padding: 50px !important;
            }
        }
    }
`;

export default React.memo(NZUACModal);
